<template>
  <basic-container>
    <el-form
      ref="searchForm"
      :model="query"
      label-width="100px"
      margin-top="0"
    >
      <el-row :gutter="0">

        <el-col :span="12">
          <el-form-item label="交易日期" prop="dateRange">
            <el-date-picker
              style="width:100%;"
              v-model="dateRange"
              type="daterange"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="收费项目" prop="feeTaxItemId">
            <el-select
              v-model="query.feeTaxItemId"
              clearable
            >
              <el-option
                v-for="(item, index) in feeTaxItemList"
                :key="index"
                :label="item.taxFeeSortName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="text-align:right;">
        <el-form-item>
          <el-button size="small"
                     type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     @click.prevent="submitSearchForm">搜索
          </el-button >
          <el-button size="small"
                     type="white"
                     @click="searchReset"
                     icon="el-icon-delete">清空
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :search.sync="searchForm"
               :page="page"
               :permission="permissionList"
               v-model="form"
               ref="crud"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">

      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          ize="small"
          v-if="(scope.row.invoiceStatus == 0
          || scope.row.invoiceStatus == 2
          || scope.row.invoiceStatus == 3)
          && scope.row.payStatus == 1
          && permissionList.issueBtn"
          @click="newOpenApplyInvoiceDialog(scope.row)"
        >开票
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if=" scope.row.invoiceStatus == 1 && permissionList.downloadBtn"
          @click="downloadFile(scope.row)"
        >下载
        </el-button>
      </template>

      <template slot="feeInvoiceNo" slot-scope="scope">
        <div style="color: #409EFF;cursor: pointer;" @click="openTaxInvoiceDetail(scope.row)">
          <span>{{ scope.row.feeInvoiceNo }}</span>
        </div>
      </template>

      <template slot="invoiceStatus" slot-scope="scope">
        <div style="color: #409EFF;cursor: pointer;" @click="openTaxInvoiceRecord(scope.row)">
          <span>{{invoiceStatusList.find(ele => ele.value == scope.row.invoiceStatus).label}}</span>
        </div>
      </template>
    </avue-crud>

    <el-dialog
      title="发票查看"
      width="60%"
      v-if="showDetail"
      :visible.sync="showDetail"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <TaxInvoiceDetail
        v-if="showDetail"
        :searchObj="searchDetailObj"
        @close="closeDetail"
      ></TaxInvoiceDetail>
    </el-dialog>

<!--  发票列表  -->
    <TaxInvoiceRecordPage
      v-if="invoiceRecordVisible"
      :visible.sync="invoiceRecordVisible"
      @close="invoiceRecordVisible = false"
      :businessSource="this.businessSource"
      :feePayId="this.invoiceRecordSearchId">
    </TaxInvoiceRecordPage>

<!--  开发票的页面  -->
    <TaxInvoiceApplyDialog ref="taxInvoiceApplyDialog" @close="onLoad" />
    <InvoiceDownloadDialog ref="InvoiceDownloadDialog" />
  </basic-container>
</template>

<script>
import {
  getPage,
} from "@/api/v4ward/pay/payqrcodepayrecord.js";
import {mapGetters} from "vuex";
import TaxInvoiceDetail from '@/views/v4ward/digitaltickets/taxinvoicerecord/compoents/TaxInvoiceDetail.vue';
import dayjs from "dayjs";
import TaxInvoiceRecordPage from '@/views/v4ward/payrecord/compoents/tax-invoice-record-page.vue';
import TaxInvoiceApplyDialog from '@/views/v4ward/digitaltickets/compoents/tax-invoice-apply-dialog';
import InvoiceDownloadDialog from '@/views/v4ward/digitaltickets/compoents/invoice-download-dialog';
import {
  getList,
} from "@/api/v4ward/digitaltickets/feeitemtax/FeeItemTax.js";

export default {
  components: {
    TaxInvoiceDetail,
    TaxInvoiceRecordPage,
    TaxInvoiceApplyDialog,
    InvoiceDownloadDialog,
  },
  data() {
    return {
      feeTaxItemList:[],
      invoiceRecordVisible:false,
      dateRange:[],
      fileUrl:'',
      showDetail:false,
      searchDetailObj:{},
      invoiceStatusList:[
        { label: '未开票', value: '0' },
        { label: '开票成功', value: '1' },
        { label: '开票失败', value: '2' },
        { label: '已红冲', value: '3' },
        { label: '开票中', value: '4' },
      ],
      form: {
      },
      query: {
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      tempFeeTax: '',
      option: {
        labelWidth: 140,
        menuWidth: 120,
        // indexLabel:"序号",
        menu: true,
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        // searchBtn: false,
        // emptyBtn: false,
        searchMenuSpan: 18,
        border: true,
        // index: true,
        viewBtn: false,
        dialogClickModal: false,
        column: [
          {
            label: "订单编码",
            prop: "orderNo",
            width: 170,
          },
          {
            label: "订单时间",
            prop: "createTime",
            width: 160,
          },
          {
            label: "商户名称",
            prop: "wpMchName",
            width: 100,
          },
          {
            label: "门店名称",
            prop: "storeName",
          },
          {
            label: "联系人",
            prop: "contact",
          },
          {
            label: "联系电话",
            prop: "phone",
          },
          {
            label: "交易金额",
            prop: "payAmount",
          },
          {
            label: "收费项目",
            prop: "taxFeeSortName",
          },
          {
            label: "发票号",
            prop: "feeInvoiceNo",
            width: 170,
            slot: true,
          },
          {
            label: "发票状态",
            prop: "invoiceStatus",
            width: 100,
            slot: true,
          },
          {
            label: "支付方式",
            prop: "payType",
            dicData: [
              { label: '微信', value: '1' },
              { label: '支付宝', value: '2' },
              { label: '其它', value: '3' },
            ],
          },
          {
            label: "交易时间",
            prop: "payTime",
            width: 130,
          },
          {
            label: "交易类型",
            prop: "tradeType",
          },
          {
            label: "备注",
            prop: "remark",
            width: 130,
          },
        ]
      },
      data: [],
      searchForm:{

      },
      feeTaxList: [],
    };
  },
  watch: {
  },
  mounted(){
    this.adjustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  created(){
    this.initFeeTaxItemList()
    this.onLoad();
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        issueBtn: this.vaildData(this.permission.qr_code_pay_record_issue, false),
        downloadBtn: this.vaildData(this.permission.qr_code_pay_record_download, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  methods: {
    //获取税收收费费项列表
    initFeeTaxItemList(){
      getList().then((res) => {
        if(res.data){
          this.feeTaxItemList = res.data;
        }else{
          this.feeTaxItemList =[];
        }
      });
    },
    //打开开具发票的页面
    newOpenApplyInvoiceDialog(row) {
      let invoiceData = Object.assign({}, row);
      invoiceData.businessType = '31';
      invoiceData.feePayId = row.id;
      invoiceData.sellerId = row.sellerId;
      invoiceData.isQrCodePay = true;
      this.$refs.taxInvoiceApplyDialog.openDialog(invoiceData);
    },
    //打开发票详情页面
    openTaxInvoiceDetail(row){
      this.searchDetailObj = {invoiceNo:row.feeInvoiceNo};
      this.showDetail = true;
    },
    //打开发票开具记录页面
    openTaxInvoiceRecord(row){
      this.invoiceRecordVisible = true;
      this.invoiceRecordSearchId = row.id;
      this.businessSource = 3;
    },
    //下载发票
    downloadFile(row) {
      let invoiceData = Object.assign({}, row);
      this.$refs.InvoiceDownloadDialog.openDialog(invoiceData);
    },
    closeDetail(){
      this.searchDetailObj = {};
      this.showDetail = false;
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    adjustView() {
      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    searchReset() {
      setTimeout(()=>{
        this.query.feeTaxItemId = '';
        this.dateRange = [];
        this.query.searchStartTime = '';
        this.query.searchEndTime = '';
        this.onLoad();
      },0)
    },
    searchChange() {
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if(this.dateRange && this.dateRange[0]){
        this.query.searchStartTime = dayjs(this.dateRange[0]).format('YYYY-MM-DD 00:00:00');
        this.query.searchEndTime = dayjs(this.dateRange[1]).format('YYYY-MM-DD 23:59:59');
      }else{
        this.query.searchStartTime = '';
        this.query.searchEndTime = '';
      }
      getPage(
        Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
      ).then(({data}) => {
        this.page.total = data.total;
        this.data = data.records;
        console.log('thos.data', data);
        this.loading = false;
        this.selectionClear();
      });
    }
  }
};
</script>

<!--最大化-->
<style lang="scss" scoped>
::v-deep .el-form-item {
  width: 100%;
}
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}
</style>
